import { Flex } from 'antd';
import CardDetailButton from '../cardDetailButton/cardDetailButton';
import InteractiveCard from '../common/interactiveCard';
import FavouriteStatus from '../favouriteStatus/favouriteStatus';
import { Divider } from '../Ant';
import { Mobile, ProfileUser } from '../icons';
import { useTranslation } from 'react-i18next';
import CardData from '../dashboard/cardData';
import { ICustomer } from '../../interface/customer';
import { cardBorderColorMapping, ICustomerType, tagColorMapping } from '../../constants/customer';
import { useLanguage } from '../../context/LanguageContext';
import { displayFullCountryName } from '../../constants/utilityFunctions';
import NoteIcons from '../common/NoteIcons';

const CustomerCard = ({
  customer,
  onClick,
  isSelected,
}: {
  customer: ICustomer;
  onClick: () => void;
  isSelected?: boolean;
}) => {
  const { t } = useTranslation();
  const { getAppLanguageCode } = useLanguage();
  const customerNumber = customer?.companyNumber ?? customer?.privatePersonNumber ?? null;
  return (
    <InteractiveCard
      data-testid="customer-card"
      className={`pointer w-full customer-card ${cardBorderColorMapping[customer?.type]} ${isSelected ? 'transaction-active-card' : ''}`}
      onActivate={onClick}
    >
      <Flex justify="space-between" align="center" className="pb-10">
        <Flex gap={10} align="center">
          <Flex
            justify="center"
            align="center"
            data-testid={`customer-status-chip-${customer?.type}`}
            className={`status-chip ${tagColorMapping[customer?.type]}`}
          >
            {customer.type === ICustomerType.COMPANY
              ? t('customer:customerType.company')
              : t('customer:customerType.privatePerson')}
          </Flex>
          <NoteIcons
            hasImportantNotes={customer?.hasImportantNotes}
            hasNotes={customer?.hasNotes}
          />
        </Flex>
        <Flex gap={10} align="center">
          <FavouriteStatus
            isFavourite={customer?.isFavorite}
            testId={`favorite-icon-${customer?.id}`}
            tooltip={t('common:favorite')}
          />
          <CardDetailButton onOpen={onClick} testId={`go-detail-icon-${customer?.id}`} />
        </Flex>
      </Flex>
      <Divider className="mb-10" />
      <Flex vertical gap={10}>
        <CardData
          type="customer"
          icon={<ProfileUser />}
          title={t('customer:customer')}
          content={customerNumber != null ? `${customerNumber} - ${customer.name}` : customer.name}
          subcontent={displayFullCountryName(customer?.homeCountry, getAppLanguageCode()) ?? ''}
          contentclass="lineclamp-1"
        />
        <CardData
          type="phone"
          icon={<Mobile />}
          title={t('customer:phoneNumber')}
          content={
            !customer?.primaryPhone || customer?.primaryPhone === '' ? '-' : customer?.primaryPhone
          }
        />
      </Flex>
    </InteractiveCard>
  );
};

export default CustomerCard;
